export const SET_LABOR_RATES = 'SetLaborRates';
export const ADD_SELECTED_LABOR_CODE = 'AddSelectedLaborCode';
export const REMOVE_SELECTED_LABOR_CODE = 'RemoveSelectedLaborCode';
export const SET_SELECTED_DEFECT_CODE = 'SetSelectedDefectCode';
export const RESET_LABOR_RATES = 'ResetLaborRates';
